import { render, staticRenderFns } from "./ActHistoryCard.vue?vue&type=template&id=1daecb5d&"
import script from "./ActHistoryCard.vue?vue&type=script&lang=ts&"
export * from "./ActHistoryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle})
